import { forwardRef, type ReactNode, type Ref } from 'react';
import { Box, type BoxProps } from '../Box/Box.js';
import './Center.css';

export interface CenterProps extends BoxProps {
  inline?: boolean;
}

/** Center its children both axes. */
export const Center = forwardRef(function Center(
  { inline, children, ...rest }: CenterProps,
  ref: Ref<HTMLElement>
): ReactNode {
  return (
    <Box
      ref={ref}
      {...rest}
      className={['rr-center', inline && 'rr-center--inline', rest.className].filter(Boolean).join(' ')}
    >
      {children}
    </Box>
  );
});
